import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { AxiosResponseAndError } from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

export type ProjectDocumentUploadResponse = {
  documentName: string;
  documentUrl: string;
};

function useProjectDocumentUploadMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<{ data: ProjectDocumentUploadResponse }>["response"],
    AxiosResponseAndError<{ data: ProjectDocumentUploadResponse }>["error"],
    FormData
  >({
    mutationFn: (data) =>
      ApiRequest.post<{ data: ProjectDocumentUploadResponse }>(
        requestURLs.projectDocumentUpload,
        data,
      ),
  });

  return mutation;
}

export default useProjectDocumentUploadMutation;
